var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarReviewOn = function SvgNavbarReviewOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M3.75 19.5v-18h16.5v21H6.75a3 3 0 0 1-3-3m12.75-12h-9V6h9zm-9 3.75h9v-1.5h-9zM12 15H7.5v-1.5H12z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarReviewOn;